<div class="container">
	<div class="modal-header">
		<div class="col-xs-11 col-md-11">
			<h4 class="modal-title fw-bold word-wrap"><span jhiTranslate="merge-germplasm.progeny.title">Germplasm Progeny:</span> {{germplasm?.preferredName}} (GID: {{gid}})</h4>
		</div>
		<div class="col-xs-1 col-md-1">
			<button type="button" class="btn-close" data-bs-dismiss="modal" aria-hidden="true"
					(click)="dismiss()">
			</button>
		</div>
	</div>
	<div class="modal-body">
		<div style="overflow-y: auto; max-height: 500px;">
			<div class="table-responsive">
				<table class="table table-striped table-bordered table-curved">
					<thead>
					<tr>
						<th jhiTranslate="search-germplasm.column.gid"><span>GID</span>
						<th jhiTranslate="merge-germplasm.column.designation"><span>DESIGNATION</span>
					</tr>
					</thead>
					<tbody>
					<tr *ngFor="let progeny of germplasmProgenies">
						<td><a class="link" (click)="openGermplasmDetailsInTab(progeny.gid)">{{progeny.gid}}</a></td>
						<td><a class="link" (click)="openGermplasmDetailsInTab(progeny.gid)">{{progeny.designation}}</a></td>
					</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</div>
